import React, { useState } from 'react'
import { TbArrowBackUpDouble } from 'react-icons/tb'
import CodeHighlight from '../../components/CodeHighlight'
import { installFramer } from '../Hover/code'
import { motion } from 'framer-motion'
import { codePage1 } from './code'

function Page() {
    const [activeTab, setActiveTab] = useState(0);

    const tabContent = [
        { title: "Home", content: <p>Welcome to the home tab!</p>, bg : 'bg-red-600' },
        { title: "Profile", content: <p>This is your profile tab.</p>, bg : 'bg-blue-600' },
        { title: "Settings", content: <p>Here are your settings.</p>, bg : 'bg-yellow-600' },
    ];

    const [transform, setTransform] = useState(0);

    const variantsScale = {
        initial: { scale : 0 },
        animate: { scale : 1 },
        exit: { scale : 0, transition : { duration : 0.1 } },
    };

    const variantsX = {
        initial: { x : '100%' },
        animate: { x : 0 },
        exit: { x : '-100%', transition : { duration : 0.1 } },
    };
    return (
        <div className='w-screen bg-[#1e1e1e] text-white overflow-auto flex items-center justify-center h-screen'>
            <div className='w-full max-w-[1200px] no-scrollbar h-screen overflow-auto py-6 px-2'>
                <div className='flex flex-col gap-4'>
                    <a href='/' className='text-2xl md:text-3xl flex items-center gap-2 text-neutral-200'>
                        <TbArrowBackUpDouble />
                        Page Transition</a>
                    <span>
                        Page transition refers to the animated effect that occurs when a user navigates from one page to another within a web application. This enhances the user experience by creating smooth visual effects, preventing abrupt jumps between pages, and providing a more fluid navigation flow.
                    </span>
                    <CodeHighlight
                        code={installFramer}
                        title="terminal"
                        language="css"
                    />
                    <span>Example : </span>
                    <div className='flex items-center gap-2'>
                        <div onClick={() => setTransform(0)} className={`${transform === 0 ? 'bg-blue-500' : 'bg-gray-500'} px-2 py-1 hover:scale-95 duration-200 transition-all cursor-pointer rounded-md`}>Scale</div>
                        <div onClick={() => setTransform(1)} className={`${transform === 1 ? 'bg-blue-500' : 'bg-gray-500'} px-2 py-1 hover:scale-95 duration-200 transition-all cursor-pointer rounded-md`}>TranslateX</div>
                    </div>
                    <div className='w-full h-[300px] rounded-lg flex overflow-hidden relative items-center justify-center bg-neutral-700'>
                        <div className='flex items-center z-20 absolute top-0'>
                            {tabContent.map((tab, index) => (
                                <div
                                    key={index}
                                    onClick={() => setActiveTab(index)}
                                    style={{
                                        margin: "0 10px",
                                        padding: "10px",
                                        borderBottom: activeTab === index ? "2px solid black" : "none",
                                    }}
                                >
                                    {tab.title}
                                </div>
                            ))}
                        </div>
                        <motion.div
                            key={activeTab} 
                            initial="initial"
                            animate="animate"
                            className={`w-full h-full ${tabContent[activeTab].bg} flex items-center justify-center`}
                            exit="exit"
                            variants={transform === 0 ?variantsScale : variantsX}
                            transition={{ duration: 1, ease : [0.22, 1, 0.36, 1] }}
                        >
                            {tabContent[activeTab].content}
                        </motion.div>
                    </div>
                    <span>Source Code : </span>
                    <CodeHighlight
                        code={codePage1}
                        title="terminal"
                        language="javascript"
                    />
                    <span>
                    The code above is a simple example of a page transition, you can change it according to your wishes in terms of time duration, and the animation that will run. You can also combine several methods, such as combining scale animations and also x direction to enter and exit the page. You can also add component load animations that I have made for example <a href='/load-animation' className='text-blue-500'>on this page</a> to make your website more varied
                    </span>
                </div>
            </div>
        </div>
    )
}

export default Page
